
<template>
  <div>
    <div class="form-row div-valign">
      
      <div class="form-group col-md-6">
        <label>วันที่ลงสัญญา
          <!-- <span class="text-white">PTTGC_1</span> -->
        </label>

        <date-picker
          v-model="ctrDate"
          name="ctrDate"
          ref="ctrDate"
          format="DD/MM/YYYY"
          data-vv-as="วันที่ลงสัญญา"
          lang="th"
          :class="{'input': true, 'is-danger': errors.has('ctrDate') }"
          placeholder
        ></date-picker>
        
      </div>

      <div class="form-group col-md-12">
        <label>
          รายละเอียดโครงการ/รายละเอียดสัญญา
          <!-- <span class="text-white">PTTGC_1</span> -->
        </label>
        <input
          v-model="beneficiaryRemark"
          name="beneficiaryRemark"
          data-vv-as="รายละเอียดโครงการ/รายละเอียดสัญญา"
          v-validate="{ required :this.lgType!=='7'}"
          :class="{'input': true, 'is-danger': errors.has('beneficiaryRemark') }"
          type="text"
          class="form-control"
        >

        <span v-show="errors.has('beneficiaryRemark')" class="help is-danger">{{ errors.first('beneficiaryRemark') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
//import DatePicker from "vue2-datepicker";
import DatePicker from "@/resources/datepicker/vue2-datepicker";
import moment from "moment";

export default {
  inject: ["$validator"],
  props: ["reqType","appVo","lgType"],
  components: {
    DatePicker
  },
  data() {
    return {
      ctrDate: "",
      beneficiaryRemark: ""
    };
  },
  mounted() {
    // initial ค่ากรณีที่เป็น ต่ออายุและ เพิ่มวงเงิน
    if(this.appVo){     
      this.ctrDate = moment(this.appVo.ctrDate, 'DD/MM/YYYY');
      this.beneficiaryRemark = this.appVo.beneficiaryRemark;
    }
  },    
  watch: {
    ctrDate(newDate, oldDate) {
      this.$emit("childExtToParent", {
        ctrDate: this.ctrDate,
        beneficiaryRemark: this.beneficiaryRemark
      });
    },
    beneficiaryRemark(newDate, oldDate) {
      this.$emit("childExtToParent", {
        ctrDate: this.ctrDate,
        beneficiaryRemark: this.beneficiaryRemark
      });
    }
  }
};
</script>
                          
